
import { Component, Prop, Model, Vue, Watch } from "vue-property-decorator";

@Component
export class PFormSwitch extends Vue {
  @Model("intput") readonly checked!: any;
  @Watch("checked")
  onChangeChecked() {
    this.isCheckedFun();
  }

  @Prop({ required: false, default: true }) value!: any;
  @Prop({ required: false, default: false }) unchecked_value!: any;
  @Prop({ required: false, default: false }) readonly!: boolean;

  public isChecked: boolean;
  public defaultCheked: boolean;

  constructor() {
    super();
    this.isChecked = false;
    this.defaultCheked = false;
  }
  get giveMeClassSwitch(): string {
    let returnTemp = "";
    if (this.isChecked) {
      returnTemp = "checkTrue_PFormSwitch";
    } else {
      returnTemp = "checkFalse_PFormSwitch";
    }
    if (this.readonly) {
      returnTemp = returnTemp + " readonly_PFormSwitch";
    }
    return returnTemp;
  }

  change(): void {
    if (!this.readonly) {
      this.isChecked = !this.isChecked;
      if (this.isChecked) {
        this.$emit("intput", this.value);
        this.$emit("change", this.value);
      } else {
        this.$emit("intput", this.unchecked_value);
        this.$emit("change", this.unchecked_value);
      }
    }
  }
  isCheckedFun(): void {
    if (this.value === this.checked) {
      this.defaultCheked = true;
      this.isChecked = true;
    } else {
      this.defaultCheked = false;
      this.isChecked = false;
    }
  }

  mounted(): void {
    this.isCheckedFun();
  }
  get dameClassReadOnly(): string {
    if (this.readonly) {
      return "sololectura";
    } else {
      return "";
    }
  }
}
export default PFormSwitch;
